// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.105.1_esbuild@0.28.1_/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.105.1_esbuild@0.28.1_/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.RealTimeContext-noInteract .DashboardComponent-noInteract {
  display: inline !important;
  display: initial !important;
}
.RealTimeContext-noInteract .toolbarWrapper {
  display: none;
}`, "",{"version":3,"sources":["webpack://./src/contexts/RealTimeContext/index.scss"],"names":[],"mappings":"AACE;EACE,0BAAA;EAAA,2BAAA;AAAJ;AAEE;EACE,aAAA;AAAJ","sourcesContent":[".RealTimeContext-noInteract {\n  .DashboardComponent-noInteract {\n    display: initial !important;\n  }\n  .toolbarWrapper {\n    display: none;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
